export default __webpack_public_path__ + "static/cristina-tamara-b94244a8b3afbb9fa714c0f4096ab643.png";